import TimelineSeparator from '@mui/lab/TimelineSeparator';
export default TimelineSeparator;
export * from '@mui/lab/TimelineSeparator';
